import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { StepperInfo, StepperInfoContext } from '../types/stepper-info.type';

export const STEP_INFO_MAP: Record<string | number, StepperInfo> = {
  1: {
    currentStep: 1,
    route: '/inscription/etape-1',
    title: 'Administrateur',
    nextTitle: 'Représentant légal',
  },
  2: {
    currentStep: 2,
    route: '/inscription/etape-2',
    title: 'Représentant légal',
    nextTitle: 'Informations complémentaires',
  },
  3: {
    currentStep: 3,
    route: '/inscription/etape-3',
    title: 'Informations complémentaires',
  },
};

export function useStepperInfo(args: UseStepperInfoArgs) {
  const { step } = args;

  const { setStepperInfo } = useOutletContext<StepperInfoContext>();

  useEffect(() => {
    setStepperInfo?.(STEP_INFO_MAP[step]);
  }, [step, setStepperInfo]);
}

interface UseStepperInfoArgs {
  step: number;
}